<template>
    <div class="feature-list__one">
        <div class="row">
            <div v-for="(item, x) in items" :key="x" class="col-lg-6 wow move-up">
                <div class="grid-item animate">
                    <div class="ht-box-icon style-01">
                        <div class="icon-box-wrap">
                            <div class="image">
                                <img :src="item.icon" class="img-fluid" alt="aeroland-app-showcase-box-icon-image-01" loading="lazy">
                            </div>
                            <div class="content">
                                <h6 class="heading">{{ $t(item.heading) }}</h6>
                                <div class="text">{{ $t(item.text) }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FeatureApp',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-01.png'), 
                        heading: 'fikirleribirlestir', 
                        text: 'Bu uygulamayı tercihlerine göre her yerden insanların fikirlerinin buluştuğu bir platform olarak düşünün.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-02.png'), 
                        heading: 'planyap', 
                        text: 'İşiniz daha iyi bir Yazılımı hakediyor, Geçiş Planını yap'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-03.png'), 
                        heading: 'zamaniyonet', 
                        text: 'Zamanı iyi Yönet, Kullanımı kolay olsun'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-04.png'), 
                        heading: 'mobilcalis', 
                        text: 'Her platformda çalışarak veriye hızlı ulaş'
                    },
                ]
            }
        }
    }
</script>
